function hasHiddenComparisonSeries({
  activeColorVisionIndex,
  comparisonSeriesIndexes,
  index
}) {
  if (comparisonSeriesIndexes.length === 0) {
    return false;
  }
  const comparisonSeries = comparisonSeriesIndexes.find(({
    comparisonIndex
  }) => comparisonIndex === index);
  if (comparisonSeries == null) {
    return false;
  }
  return comparisonSeries.comparisonIndex === index && activeColorVisionIndex !== comparisonSeries.originalIndex;
}

export { hasHiddenComparisonSeries };
